export default "__VITE_ASSET__a9c8a3c7__"